import { Button, Pagination, Selection } from '@nextui-org/react';
import { TableConfig } from './types';

interface BottomContentProps {
  selectedKeys: Selection;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filteredItems: any[];
  page: number;
  pages: number;
  onPageChange: (page: number) => void;
  config: TableConfig;
}

export function BottomContent({
  selectedKeys,
  filteredItems,
  page,
  pages,
  onPageChange,
  config,
}: BottomContentProps) {
  if (!config.pagination?.enabled || pages <= 1) return null;

  return (
    <div className="flex w-full items-center justify-between py-2">
      {config.showSelectedItems ? (
        <span className="w-[30%] text-small text-default-400">
          {selectedKeys === 'all'
            ? 'All items selected'
            : `${selectedKeys.size} of ${filteredItems.length} selected`}
        </span>
      ) : (
        <div></div>
      )}
      <Pagination
        isCompact
        showControls={config.pagination.showControls}
        showShadow={config.pagination.showShadow}
        color="primary"
        page={page}
        total={pages}
        onChange={onPageChange}
      />
      {config.showPrevNextControls && (
        <div className="hidden sm:flex w-[30%] justify-end gap-2">
          <Button
            isDisabled={pages === 1}
            size="sm"
            variant="flat"
            onPress={() => onPageChange(page - 1)}
          >
            Previous
          </Button>
          <Button
            isDisabled={pages === 1}
            size="sm"
            variant="flat"
            onPress={() => onPageChange(page + 1)}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
}
